/* Responsibility: keep track of common constant values. */
export default {
    SORT_CRITERIA: 'sortCriteria',
    CLIENT_DATE_FORMAT: 'DD.MM.YYYY',
    SERVER_DATE_FORMAT: 'YYYY-MM-DD',
    READABLE_DATE_FORMAT: 'ddd DD MMM',
    READABLE_DATE_FORMAT_SHORT: 'ddd DD.MM',
};
